import { UncontrolledToggle } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../translations';
import { ContinuousIcon } from '../continuous/ContinuousIcon';
import { DictationIcon } from '../dictation/DictationIcon';
import type { AiAssistantMode } from '../types';
type ModeToggleProps = {
   mode: AiAssistantMode;
   onModeChange: (mode: AiAssistantMode) => void;
   disabled?: boolean;
};

/**
 * ModeToggle — switches between DICTATION (inactive) and CONTINUOUS (active) modes.
 * Left slot: Dyktowanie label, right slot: Nagranie rozmowy label.
 */
export const ModeToggle = (props: ModeToggleProps): JSX.Element => {
   const handleChange = (active: boolean): void => {
      props.onModeChange(active ? 'CONTINUOUS' : 'DICTATION');
   };

   return (
      <UncontrolledToggle
         testId={'modeToggle'}
         active={props.mode === 'CONTINUOUS'}
         onActiveChange={handleChange}
         asSwitch
         icon={props.mode === 'CONTINUOUS' ? <ContinuousIcon /> : <DictationIcon />}
         disabled={props.disabled}
         label={translationKeys.modeSelector.label}
         leftSlot={<Translate>{translationKeys.modeSelector.dictation}</Translate>}
         rightSlot={<Translate>{translationKeys.modeSelector.continuous}</Translate>}
      />
   );
};
